// chatrooms.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_CHATROOMS,
  MERGE_CHATROOM_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Chatrooms.
 * @module reducer/chatrooms
 */
const chatrooms = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_CHATROOMS:
      return _ADD_CHATROOMS(action.payload)(state);
    case MERGE_CHATROOM_DATA:
      return _MERGE_CHATROOM_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Add chatrooms
 * @kind reducer/actionType
 * @name ADD_CHATROOMS
 * @param {object} { chatrooms } - chatrooms use id as key.
 * @return {Immutable.Map} New state
 */
const _ADD_CHATROOMS =
  ({ chatrooms }) =>
  state => {
    const chatroomIds = Object.keys(chatrooms);
    chatroomIds
      .filter(
        chatroomId =>
          state.getIn([chatroomId, 'lastMessageId']) &&
          state.getIn([chatroomId, 'lastMessageId']) ===
            chatrooms[chatroomId]?.lastMessageId
      )
      .filter(
        chatroomId =>
          state.getIn([chatroomId, 'pinned']) &&
          state.getIn([chatroomId, 'pinned']) === chatrooms[chatroomId]?.pinned
      )
      .forEach(id => {
        delete chatrooms[id];
      });
    return state.mergeDeep(chatrooms);
  };

/**
 * Merge chatroom data
 * @kind reducer/actionType
 * @name MERGE_CHATROOMS_DATA
 * @param {array} {selectPath} - chatroom data select path
 * @param {any} {data} - chatroom data
 * @return {Immutable.Map} New state
 */
const _MERGE_CHATROOM_DATA =
  ({ selectPath, data }) =>
  state => {
    return state.mergeDeepIn(selectPath, data);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default chatrooms;
